import { uidGenerator } from "@/lib/Helpers/uidGenerator";

// Silently update the url with clickId value
// it does not trigger hooks like useReactiveSearchParams
export function createAndAppendClickId(searchId: string): string {
  const currentParams = new URLSearchParams(window.location.search);
  const newClickId = uidGenerator().generate(searchId);
  currentParams.set("clickId", newClickId);
  window.history.replaceState(
    {},
    "",
    `${window.location.pathname}?${currentParams}`
  );
  return newClickId;
}
